export enum FileStatus {
    New = 0,
    Processed = 1,
}